// extracted by mini-css-extract-plugin
module.exports = {"container":"_2TV71BUdga9UA_0EGTWe_f","content":"_2iujdcK4p_bKU4jBuaJX_z"};